module.exports = __webpack_public_path__ + "static/index/img/baikal-507.ffc58ef4.jpg";